var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarthquake2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6,68.3V35.9l5.7,4.6l6.3-7.9L55.3,1L16.1,32.6l6.3,7.9l5.7-4.6v32.4l-27.4,0v40.4H110V68.3L82.6,68.3z M61.2,84.8 l-5.5,8.2l2,3.4c0,0-8.1,9.9-7.9,9.6c0.2-0.4,1.9-9.4,1.9-9.4l-4.1-5.3l5.3-6.3l-4.5-6.6l2-8.8h12.6l-5.4,9.8L61.2,84.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92,53.5c0,3,1.3,4.6,2.3,5.9c0.9,1.1,1.5,1.8,1.5,3.5h3.8c0-3-1.3-4.6-2.3-5.9c-0.9-1.1-1.5-1.8-1.5-3.5 c0-1.7,0.6-2.4,1.5-3.5c1-1.3,2.3-2.9,2.3-5.9s-1.3-4.6-2.3-5.9c-0.9-1.1-1.5-1.8-1.5-3.5c0-1.7,0.6-2.4,1.5-3.5 c1-1.3,2.3-2.9,2.3-5.9h-3.8c0,1.7-0.6,2.4-1.5,3.5c-1,1.3-2.3,2.9-2.3,5.9c0,3,1.3,4.6,2.3,5.9c0.9,1.1,1.5,1.8,1.5,3.5 c0,1.7-0.6,2.4-1.5,3.5C93.3,48.9,92,50.5,92,53.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,53.5c0,3,1.3,4.6,2.3,5.9c0.9,1.1,1.5,1.8,1.5,3.5h3.8c0-3-1.3-4.6-2.3-5.9c-0.9-1.1-1.5-1.8-1.5-3.5 c0-1.7,0.6-2.4,1.5-3.5c1-1.3,2.3-2.9,2.3-5.9s-1.3-4.6-2.3-5.9c-0.9-1.1-1.5-1.8-1.5-3.5c0-1.7,0.6-2.4,1.5-3.5 c1-1.3,2.3-2.9,2.3-5.9h-3.8c0,1.7-0.6,2.4-1.5,3.5c-1,1.3-2.3,2.9-2.3,5.9c0,3,1.3,4.6,2.3,5.9c0.9,1.1,1.5,1.8,1.5,3.5 c0,1.7-0.6,2.4-1.5,3.5C13,48.9,11.7,50.5,11.7,53.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake2);
export default __webpack_public_path__ + "static/media/earthquake-2.39570367035d08a5aea5ad9fd1e296c4.svg";
export { ForwardRef as ReactComponent };